<template>
    <div>
        <slot />
        <VJoyFormError v-if="errors?.length">
            <ul>
                <li v-for="error of errors" :key="error">{{ error }}</li>
            </ul>
        </VJoyFormError>
    </div>
</template>

<script setup lang="ts">
    import {VJoyFormError} from '@maltjoy/core-vue';

    defineProps<{errors?: string[]}>();
</script>
